import {
	ForexToApproveCount,
	ForexToApproveCountDTO,
	PaymentOrderCountDTO
} from "@/feature/Forex/api/approval/forex-approval.interface";
import { ForexStatus } from "@/feature/Forex/api/history/forex-history.interface";
import { profileEntity } from "@/models/modules/profile/entity";
import { UserRole } from "@/mixins/role/interface";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";

export const getForexStatusFromUserRole = (): ForexStatus =>
	profileEntity?.profileData?.role === UserRole.DIRECTOR
		? ForexStatus.ON_DIRECTOR_LIST
		: ForexStatus.ON_ACCOUNTANT_LIST;

export const mapCountByPaymentOrderCount = (
	response: PaymentOrderCountDTO[] | null
): number => {
	const status = getForexStatusFromUserRole();

	return (response || [])
		.find(item => item.status === status)
		?.count || 0;
};

export const mapForexToApproveCount = (
	response: ForexToApproveCountDTO | null
): ForexToApproveCount => ({
	[ForexOperationType.ALL]: response?.all || 0,
	[ForexOperationType.BUY]: response?.buy || 0,
	[ForexOperationType.SELL]: response?.sell || 0,
});